import gql from 'graphql-tag';

import dokkioUserFragment from '../fragments/dokkioUserFragment';

export const mutationCreateDokkioUser = gql`
  mutation createDokkioUser (
    $primaryFirstName: String!
    $primaryLastName: String!
    $primaryEmail: String!
    $password: String
  ) {
    createDokkioUser (
      primaryFirstName: $primaryFirstName
      primaryLastName: $primaryLastName
      primaryEmail: $primaryEmail
      password: $password
    ) {
      ...dokkioUserFragment
    }
  }
  ${dokkioUserFragment}
`;
export default mutationCreateDokkioUser;
